// extracted by mini-css-extract-plugin
export default {"close":"Views_close__TEhLf","onOrder":"Views_onOrder__SVTWu"};